
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/[tab]/[id]",
      function () {
        return require("private-next-pages/company/[tab]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/[tab]/[id]"])
      });
    }
  